import React, {Component} from "react";
import {Box, TextField} from "@mui/material";
import withStyles from "@mui/styles/withStyles";

const styles = {
    boxes: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        margin: "5px 0"
    },
    box: {
        margin: "0 5px",
        width: "45px"
    },
    box_space: {
        width: "35px"
    },
    box_input: {
        fontSize: 25,
        textAlign: 'center'
    }
};

class MultiBox extends Component {
    constructor(props) {
        super(props);

        const expectedInputSplit = props.expectedInput.split("");
        this.inputRefs = new Array(expectedInputSplit.length);
        for (let i = 0; i < this.inputRefs.length; i++) {
            if (expectedInputSplit[i] === '/' || expectedInputSplit[i] === ' ') {
                this.inputRefs[i] = expectedInputSplit[i];
            } else {
                this.inputRefs[i] = React.createRef();
            }
        }
    }

    nextFocusableIndex(currIndex) {
        for (let i = ++currIndex; i < this.inputRefs.length; i++) {
            if (typeof this.inputRefs[i] === 'object' && this.inputRefs[i] !== null) {
                return i;
            }
        }
        return undefined;
    }

    previousFocusableIndex(currIndex) {
        for (let i = --currIndex; i >= 0; i--) {
            if (typeof this.inputRefs[i] === 'object' && this.inputRefs[i] !== null) {
                return i;
            }
        }
        return undefined;
    }

    boxChanged(event) {
        let newIndex = event.target.value !== undefined && event.target.value !== '' ?
            this.nextFocusableIndex(event.target.id)
            :
            this.previousFocusableIndex(event.target.id)
        ;
        if (newIndex !== undefined) {
            this.inputRefs[newIndex].current.focus();
        }
        // todo parse string output
        this.props.onAnswerChange(
            this.inputRefs.map(ref => {
                if (typeof ref === 'object' && ref !== null) {
                    return ref.current.value;
                }
                return ref;
            }).join(""),
            this.props.targetColId
        );
    }

    componentDidMount() {
        if (!this.props.disableAutofocus) {
            this.inputRefs[this.nextFocusableIndex(-1)].current.focus();
        }
    }

    render() {
        const {classes} = this.props;
        return (
            <form noValidate autoComplete="off">
                <Box className={classes.boxes}>
                    {
                        this.inputRefs.map((ref, i) => {
                            if (ref === ' ') {
                                return <div key={i}
                                            className={classes.box_space}
                                />
                            } else if (ref === '/') {
                                return <TextField
                                    key={i} disabled value={ref}
                                    className={classes.box}
                                    variant="standard"
                                    inputProps={{maxLength: 1, className: classes.box_input, style: {color: this.props.color}}}

                                />
                            } else {
                                return <TextField
                                    inputRef={ref} key={i}
                                    className={classes.box}
                                    onChange={this.boxChanged.bind(this)}
                                    onKeyUp={this.props.onKeyUp}
                                    variant="standard"
                                    inputProps={{maxLength: 1, className: classes.box_input, id: i, style: {color: this.props.color}}}
                                />
                            }
                        })
                    }
                </Box>
            </form>
        )
    }
}

export default withStyles(styles)(MultiBox);
